import React, { useEffect, useState } from "react";
import { Modal } from "@appkit4/react-components/modal";
import { Button } from "@appkit4/react-components/button";
import { loginRequest, msalInstance } from "../../auth/msalConfig";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const UserSessionTimeout: React.FC = () => {
  const azuresearchId = useSelector((state: RootState) => state.auth.azuresearchId)

  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!azuresearchId) return;
    const currentTime = new Date().getTime();
    const expiryTime = azuresearchId;
    const timeUntilExpiry = expiryTime - currentTime;
    if (timeUntilExpiry > 0) {
      const timeout = setTimeout(() => {
        setVisible(true);
      }, timeUntilExpiry);
      return () => clearTimeout(timeout); // Clear timeout on unmount
    } else {
      setVisible(true); // If already expired, show modal immediately
    }
  }, [azuresearchId]);

  const loginRedirect = async () => {
    await msalInstance.loginRedirect(loginRequest);
  };

  return (
    <>
      <Modal
        visible={visible}
        title={"Session Timed Out"}
        ariaLabel={"Session Timed Out"}
        closable={false}
        maskCloseable={false}
        modalStyle={{ width: "33.75rem" }}
        footerStyle={{ paddingTop: "8px", marginTop: "-8px", minHeight: "64px" }}
        header={""}
        icons={""}
        footer={
          <>
            <Button onClick={async () => await loginRedirect()}>Login</Button>
          </>
        }
        bodyStyle={{ minHeight: "92px" }}
      >
        <p>
          Your session has timed out. Please log in again. Note that you might
          need to reupload files to fetch their results.
        </p>
      </Modal>
    </>
  );
};

export default UserSessionTimeout; 